import React from "react";
import Devices  from "../modules/Devices/Devices";
export default function DevicesPage() {
  return <Devices />;
}
